const i = (t, s, e) => s === 1 ? t : e ?? `${t}s`, o = (t) => t.charAt(0).toUpperCase() + t.slice(1), l = ({
  houseNumber: t,
  street: s,
  city: e,
  state: a,
  country: c,
  postalCode: d,
  description: $
}) => [`${t ? `${t && s ? `${t} ` : `${t}`}` : ""}${s || ""}`, e, a, c, d].reduceRight((r, n) => r && n ? `${n}, ${r}` : n || r || "") || "", f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: o,
  formatAddress: l,
  pluralize: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  o as c,
  l as f,
  i as p,
  f as s
};
